<template>
	<FollowupTile
		v-if="blok"
		v-editable="blok"
	>
		<template #title>
			{{ blok.title }}
		</template>
		<template #text>
			<RichText :data="blok.text" />
		</template>
		<template #cta>
			<button
				v-if="blok.status === 'disabled'"
				type="button"
				class="btn btn-secondary btn-sm md:btn-lg shadow-xs mt-6 md:mt-12 lg:mt-20"
				:aria-label="getCtaAriaLabel(blok.cta[0].label, blok.title)"
				disabled
			>
				{{ blok.cta[0].label }}
			</button>
			<StoryblokComponent
				v-for="item in blok.cta"
				v-else
				:key="item._uid"
				:blok="item"
				:aria-label="getCtaAriaLabel(item.label, blok.title)"
				class="btn btn-primary btn-sm md:btn-lg shadow-xs mt-6 text-center"
			/>
		</template>
		<template #img>
			<div
				v-if="props.blok.status === 'disabled' && props.blok.disabledMessage?.length"
				class="flex flex-col justify-center z-1"
			>
				<div
					class="
						bg-background-secondary
						px-4
						py-3
						text-center
						text-body-secondary
						typo-body-xl
						font-bold
						"
				>
					{{ blok.disabledMessage }}
				</div>
			</div>
			<NuxtPicture
				v-if="blok.image?.filename"
				class="clip-style block h-full"
				provider="storyblok"
				width="470"
				height="470"
				:modifiers="storyblokFocusModifiers(blok.image.focus)"
				:src="blok.image.filename"
				:alt="blok.image.alt || ''"
				sizes="xs:220px md:360px lg:470px"
				:img-attrs="{class: imageAttrs}"
				loading="lazy"
			/>
		</template>
	</FollowupTile>
</template>

<script setup lang="ts">
	import type {SmallFollowupTileStoryblok} from '@/storyblok/types';
	import {getCtaAriaLabel} from '~/utils/followupTile';

	interface Props {
		blok: SmallFollowupTileStoryblok
	}

	const props = defineProps<Props>();

	const imageAttrs = computed(() => {
		let imgClass = 'w-full h-full object-cover block';
		if (props.blok.status === 'disabled') {
			imgClass += ' grayscale';
		}
		return imgClass;
	});
</script>
